<template>
  <div>
    <div class="table-responsive" v-if="proposals.length">
      <table class="table zero-configuration" :aria-label="$t('contracts_arial_label_proposal_list')">
        <thead>
          <tr>
            <th>{{$t('Address')}}</th>
            <th>{{$t('Landlord')}}</th>
            <th>{{$t('Tenant')}}</th>
            <th>{{$t('Creation Status')}}</th>
            <th>{{$t('Negotiation Status')}}</th>
            <th>{{$t('Country')}}</th>
            <th>{{$t('Created At')}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(proposal, index) in proposals" :key="index">
            <td class="templateName capitalize">
              <span v-if="proposal.property.address" class="text-bold-500">
                {{ proposal.property.address.street }},
                {{ countryName(proposal.country) }}
              </span>
              <span v-else>-</span>
              <br />
              <router-link
                :to="{
                  name: 'ContractProposalSinglePage',
                  params: { uuid: proposal.id },
                }"
                href="#"
                style="margin-top: 5px"
              >
                {{$t('View Details')}}
              </router-link>
            </td>
            <td>
              <span v-if="proposal.landlord.user">{{
                proposal.landlord.user.name ? proposal.landlord.user.name : "-"
              }}</span>
              <span v-else>{{
                proposal.landlord.invite.name
                  ? proposal.landlord.invite.name
                  : "-"
              }}</span>
            </td>
            <td v-if="proposal.tenants">
              <span v-if="proposal.tenants[0].user">{{
                proposal.tenants[0].user.name
                  ? proposal.tenants[0].user.name
                  : "-"
              }}</span>
              <span v-else>{{
                proposal.tenants[0].invite.name
                  ? proposal.tenants[0].invite.name
                  : "-"
              }}</span>
            </td>
            <td v-else>-</td>
            <td class="capitalize">
              <span v-if="proposal.creationStatus == 'draft_by_admin'"
                ><em class="bx bxs-circle default font-small-1 mr-50"></em
                >{{ proposal.creationStatus.replaceAll("_", " ") }}</span
              >
              <span v-if="proposal.creationStatus == 'draft_by_landlord'"
                ><em class="bx bxs-circle default font-small-1 mr-50"></em
                >{{ proposal.creationStatus.replaceAll("_", " ") }}</span
              >
              <span v-if="proposal.creationStatus == 'needs_approval_by_admin'"
                ><em class="bx bxs-circle info font-small-1 mr-50"></em
                >{{ proposal.creationStatus.replaceAll("_", " ") }}</span
              >
              <span
                v-if="proposal.creationStatus == 'needs_approval_by_landlord'"
                ><em class="bx bxs-circle info font-small-1 mr-50"></em
                >{{ proposal.creationStatus.replaceAll("_", " ") }}</span
              >
              <span v-if="proposal.creationStatus == 'approved'"
                ><em class="bx bxs-circle success font-small-1 mr-50"></em
                >{{ proposal.creationStatus }}</span
              >
              <span v-if="proposal.creationStatus == 'archived'"
                ><em class="bx bxs-circle warning font-small-1 mr-50"></em
                >{{ proposal.creationStatus }}</span
              >
            </td>
            <td class="capitalize">
              <span v-if="!proposal.negotiationStatus">-</span>
              <span
                v-if="
                  proposal.negotiationStatus &&
                  proposal.negotiationStatus == 'accepted_by_landlord'
                "
                ><em class="bx bxs-circle success font-small-1 mr-50"></em
                >{{ proposal.negotiationStatus.replaceAll("_", " ") }}</span
              >
              <span
                v-if="
                  proposal.negotiationStatus &&
                  proposal.negotiationStatus == 'accepted_by_all'
                "
                ><em class="bx bxs-circle success font-small-1 mr-50"></em
                >{{ proposal.negotiationStatus.replaceAll("_", " ") }}</span
              >
              <span
                v-if="
                  proposal.negotiationStatus &&
                  proposal.negotiationStatus == 'declined_by_tenant'
                "
                ><em class="bx bxs-circle danger font-small-1 mr-50"></em
                >{{ proposal.negotiationStatus.replaceAll("_", " ") }}</span
              >
              <span
                v-if="
                  proposal.negotiationStatus &&
                  proposal.negotiationStatus == 'change_requested_by_tenant'
                "
                ><em class="bx bxs-circle info font-small-1 mr-50"></em
                >{{ proposal.negotiationStatus.replaceAll("_", " ") }}</span
              >
              <span
                v-if="
                  proposal.negotiationStatus &&
                  proposal.negotiationStatus == 'archived'
                "
                ><em class="bx bxs-circle warning font-small-1 mr-50"></em
                >{{ proposal.negotiationStatus }}</span
              >
            </td>
            <td>{{ countryName(proposal.country) }}</td>
            <td>{{ proposal.createdAt.split("T")[0] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { getCountryName } from "@/app-assets/js/get-countries.js";
export default {
  props: ["proposals"],

  methods: {
    initDataTable() {
      setTimeout(function () {
        $(".zero-configuration").DataTable({
            "scrollX": true,
            "bLengthChange": false,
            "bFilter": false,
            "order": []
        });
      }, 100);
    },

    countryName(element) {
      if (element) {
        return getCountryName(element.toUpperCase());
      }
    },
  },

  mounted() {
    this.initDataTable();
  },
};
</script>

<style scoped>
    .zero-configuration td, .zero-configuration th {
        white-space: nowrap;
    }
</style>